import { FC, PropsWithChildren } from 'react'
import classNames from 'classnames'
import styles from './index.module.scss'

type Props = {
  styleType?: 'danger' | 'warning'
  align?: 'center' | 'flexStart'
}

export const Alert: FC<PropsWithChildren<Props>> = ({ children, styleType = 'danger', align = 'center' }) => {
  const className = classNames(
    styles.container,
    {
      [styles.dangerContainer]: styleType === 'danger',
      [styles.warningContainer]: styleType === 'warning',
    },
    {
      [styles.center]: align === 'center',
      [styles.flexStart]: align === 'flexStart',
    }
  )

  return <div className={className}>{children}</div>
}
